import React from 'react';
import { Edit2, Copy, Trash2, TrendingUp, Calendar, DollarSign } from 'lucide-react';

const TemplateCard = ({ template, onEdit, onDuplicate, onDelete }) => {
  const formatCurrency = (value) => {
    if (!value) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(value);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 hover:shadow-lg transition-shadow">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-foreground mb-1">{template?.templateName}</h3>
          <span className="inline-block px-2 py-1 text-xs font-medium bg-primary/10 text-primary rounded">
            {template?.projectType}
          </span>
        </div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <TrendingUp className="h-3 w-3" />
          <span>{template?.usageCount || 0} usos</span>
        </div>
      </div>

      {/* Description */}
      {template?.description && (
        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {template?.description}
        </p>
      )}

      {/* Key Parameters Preview */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground flex items-center gap-1">
            <DollarSign className="h-3 w-3" />
            Valor Total
          </span>
          <span className="font-medium text-foreground">
            {formatCurrency(template?.defaultTotalObra)}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground flex items-center gap-1">
            <Calendar className="h-3 w-3" />
            Duração
          </span>
          <span className="font-medium text-foreground">
            {template?.defaultDuracaoMeses || 0} meses
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Custo Empreiteiro</span>
          <span className="font-medium text-foreground">
            {formatCurrency(template?.defaultCustoEmpreiteiro)}
          </span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center gap-2 pt-4 border-t border-border">
        <button
          onClick={() => onEdit?.(template)}
          className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-sm font-medium text-primary hover:bg-primary/10 rounded-lg transition-colors"
        >
          <Edit2 className="h-3 w-3" />
          Editar
        </button>
        <button
          onClick={() => onDuplicate?.(template)}
          className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-sm font-medium text-foreground hover:bg-muted rounded-lg transition-colors"
        >
          <Copy className="h-3 w-3" />
          Duplicar
        </button>
        <button
          onClick={() => onDelete?.(template?.id)}
          className="px-3 py-2 text-sm font-medium text-destructive hover:bg-destructive/10 rounded-lg transition-colors"
        >
          <Trash2 className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
};

export default TemplateCard;